export default __webpack_public_path__ + "static/media/login-bg-12.bd5c6d98.jpg";